import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { NewsListCardComponent } from 'src/app/news/components/news-list-card/news-list-card.component';
import { SlicePipe } from '@angular/common';
import { NewsCardComponent } from 'src/app/news/components/news-card/news-card.component';
import { RouterLink } from '@angular/router';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
    selector: 'app-content-block-news',
    imports: [NewsListCardComponent, SlicePipe, NewsCardComponent, RouterLink, FromDictionaryPipe],
    templateUrl: './content-block-news.component.html',
    styleUrl: './content-block-news.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockNewsComponent extends ContentBlockBaseComponent {}
